export default "__VITE_ASSET__9qetFvi___"